export const environment = {
    production: false,
    contentful: {
      space: "7unabnt9bnbr",
      accessToken:
        "3IOKou-iXO0auZWu_QWnqsdZdU81Rmj1zpq8BcJBkSY"
    }
  };
  